// Threads are rendered by generating "shadow" copies of a feed-matching post
// when that post also appears as an ancestor inside another thread. Each shadow
// gets a synthetic id of the form `${realId}__shadow__${leafId}` so it can live
// as a separate entry in the posts Map (see `buildPostThreadMap` in
// post-thread.utils.ts, which the feed post list's queryFn runs).
//
// Shadow ids are a display-only concern: they must never be sent to the backend
// or used as the canonical key for per-post mutations (categorization, sentiment,
// workflow transitions, etc.). Use `realPostId` to recover the underlying post id.

export const SHADOW_ID_SEPARATOR = '__shadow__';

export function isShadowPostId(id: string): boolean {
  return typeof id === 'string' && id.includes(SHADOW_ID_SEPARATOR);
}

/** Returns the underlying real post id, stripping any shadow suffix. */
export function realPostId(id: string): string {
  if (!isShadowPostId(id)) return id;
  return id.split(SHADOW_ID_SEPARATOR)[0];
}

/** Builds a shadow id for the given real post id within a thread (by leaf id). */
export function makeShadowPostId(realId: string, leafId: string): string {
  return `${realId}${SHADOW_ID_SEPARATOR}${leafId}`;
}
